const date = {
	dateTime(date: any, addYear?: boolean, addFullMonth?: boolean, addTime?: boolean, timeSeparator?: string) : string {

		const formatMonth = (d: Date, addFullMonth?: boolean) : string => {
			const m = d.getMonth() + 1;
			if (!addFullMonth) {
				return m + '';
			}

			switch(m) {
				default:
				case 1: return 'января';
				case 2: return 'февраля';
				case 3: return 'марта';
				case 4: return 'апреля';
				case 5: return 'мая';
				case 6: return 'июня';
				case 7: return 'июля';
				case 8: return 'августа';
				case 9: return 'сентября';
				case 10: return 'октября';
				case 11: return 'ноября';
				case 12: return 'декабря';				
			}
		}	

		const formatDateHandler = (d: Date, addYear?: boolean, addFullMonth?: boolean, addTime?: boolean, timeSeparator?: string) : string => {
			const day = d.getDate();
			const month = formatMonth(d, addFullMonth);

			let formattedDate = day + (addFullMonth ? ` ${month}` : `.${month}`);
			if (addYear) {
				formattedDate += addFullMonth ? ` ${d.getFullYear()}` : `.${d.getFullYear()}`;
			}

			if (addTime) {
				if (timeSeparator?.length) {
					formattedDate += timeSeparator;
				}

				const h = d.getHours() < 10 ? '0' + d.getHours() : d.getHours() + '';
				const m = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes() + '';
				formattedDate += `${h}:${m}`;
			}

			return formattedDate;
		}

		if (typeof date === 'object') {
			return formatDateHandler(date, addYear, addFullMonth, addTime, timeSeparator);
		} else {
			const dateObj = new Date(date);
			if (isNaN(dateObj.valueOf())) {
				console.warn('can\'t format date: invalid date', date);
				return formatDateHandler(new Date(), addYear, addFullMonth, addTime, timeSeparator);
			}

			return formatDateHandler(dateObj, addYear, addFullMonth, addTime, timeSeparator);
		}
	},

	toUtcJson(date: Date, addTime?: boolean) : string {
		const d = {
			year: date.getFullYear(),
			month: date.getMonth() + 1,
			day: date.getDate(),
			hours: date.getHours(),
			minutes: date.getMinutes(),
			seconds: date.getSeconds(),
			millis: date.getMilliseconds()
		};

		let utcDateString = `${d.year}-${d.month < 10 ? `0${d.month}` : d.month}-${d.day < 10 ? `0${d.day}` : d.day}`;

		if (addTime) {
			utcDateString += `T${d.hours < 10 ? `0${d.hours}` : d.hours}:${d.minutes}:${d.seconds}.${d.millis}Z`;
		} else {
			utcDateString += `T00:00:00.000Z`;
		}
		
		return utcDateString;
	}
};

const noun = {
	conjunct(value: number, singularForm: string, pluralForm: string, strangeForm: string, locale?: string): string {
		if (!locale) {
			locale = "ru";
		}

		const valueLastDigit = value % 10;

		switch (locale) {

			default:			
			case "ru": {
				switch (valueLastDigit) {
					case 1:
						return singularForm;

					case 2:
					case 3:
					case 4:
						return strangeForm;

					default:
						return pluralForm;
				}
			}

			case "en": {
				if (valueLastDigit > 1) {
					return pluralForm;
				} else {
					return singularForm;
				}
			}
		}
	}
}

export { date, noun };
